import { template } from 'lodash';

const getVideoUrl = (sessionId, specialOpsVideoUrl) => `${specialOpsVideoUrl}${sessionId}.mp4`;

export const getTakeAwayVideo = (sessionId, specialOpsVideoUrl) => {
  if (!sessionId) return null;

  const videoUrl = getVideoUrl(sessionId, specialOpsVideoUrl);

  return {
    src: videoUrl,
    type: 'video/mp4',
  };
};

export const getTakeAwaySocial = (
  sessionId,
  score,
  phrases,
  specialOpsVideoPagePath,
) => {
  const {
    share: {
      emailSubject,
      emailBody: emailBodyTemplate,
      tweetWithScore: tweetTemplate,
      whatsAppMessageWithScore: whatsAppMessageTemplate,
    },
  } = phrases;
  const videoUrl = `${specialOpsVideoPagePath}${sessionId}`;
  const tweet = template(tweetTemplate);
  const emailBody = template(emailBodyTemplate);
  const whatsAppMessage = template(whatsAppMessageTemplate);
  const fb = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(videoUrl)}`;
  const twitter = `https://twitter.com/intent/tweet?text=${encodeURI(tweet({ score, videoUrl }))}`;
  const whatsapp = `https://api.whatsapp.com/send?text=${encodeURI(whatsAppMessage({ score, videoUrl }))}`;
  const email = `mailto:?subject=${encodeURI(emailSubject)}&body=${encodeURI(emailBody({ score, videoUrl }))}`;

  return ([
    {
      id: 'Facebook',
      url: fb,
      title: 'Share on Facebook',
    },
    {
      id: 'Twitter',
      url: twitter,
      title: 'Share on Twitter',
    },
    {
      id: 'WhatsApp',
      url: whatsapp,
      title: 'Share on WhatsApp',
    },
    {
      id: 'Email',
      url: email,
      title: 'Share on email',
    },
  ]);
};
